/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface CreateScorecardTemplateRequest
 */
export interface CreateScorecardTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateScorecardTemplateRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateScorecardTemplateRequest
     */
    parameters?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateScorecardTemplateRequest
     */
    isDraft?: boolean;
}

/**
 * Check if a given object implements the CreateScorecardTemplateRequest interface.
 */
export function instanceOfCreateScorecardTemplateRequest(value: object): boolean {
    return true;
}

export function CreateScorecardTemplateRequestFromJSON(json: any): CreateScorecardTemplateRequest {
    return CreateScorecardTemplateRequestFromJSONTyped(json, false);
}

export function CreateScorecardTemplateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateScorecardTemplateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'parameters': json['parameters'] == null ? undefined : json['parameters'],
        'isDraft': json['isDraft'] == null ? undefined : json['isDraft'],
    };
}

export function CreateScorecardTemplateRequestToJSON(value?: CreateScorecardTemplateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'parameters': value['parameters'],
        'isDraft': value['isDraft'],
    };
}

